type GuestNamePrefillState = {
  dataForBooking: { nameForm: string };
  // Guest name last prefilled; tells a prefilled name apart from one the guest typed.
  prefilledNameForm: string;
};

/**
 * Prefills the summary guest name with the lead guest's name.
 * Replaces only an empty name or the previous prefill, so a name the guest typed is kept.
 * Returns the same state when nothing changes.
 */
export const prefillGuestName = <State extends GuestNamePrefillState>(state: State, leadGuestName: string): State => {
  const nameForm = state.dataForBooking.nameForm ?? "";

  if (nameForm.trim() && nameForm !== state.prefilledNameForm) {
    return state;
  }

  return {
    ...state,
    dataForBooking: { ...state.dataForBooking, nameForm: leadGuestName },
    prefilledNameForm: leadGuestName
  };
};
